export default {
    DASTMOZDI:1,
    MAVAD_VA_MASALEH:2,
    DASTMOZD_BA_MASLEH:4,
    SAIER:3
}

export const ConstructionTypeTitle = {
	1: "دستمزدی",
    2: "مواد و مصالح",
	3: "سایر",
    4: "دستمزد با مصالح",
};

export const ConstructionTypeTitleSorted = [
    {type:1, value:"دستمزدی"},
    {type:2, value: "مواد و مصالح"},
    {type:4, value:"دستمزد با مصالح"},
    {type:3, value: "سایر"}
];